export const initialValues = {
    entity: null,
    communities: [],
    totalCommunities: 0,
    selectedCommunityId: null,
    communityFilter: '',
    buildings: null,
    loading: true,
};
